import React from 'react'

const ErrorIcon = props => {
    const stroke = props.stroke || '#EF1706'
    const height = props.height || '25'
    const width = props.width || '25'
    const customizedStyle: React.CSSProperties = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: '10px',
    }
    return (
        <div style={customizedStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 44 44">
                <g stroke={stroke} stroke-width="2.5" fill="none" fill-rule="evenodd">
                    <circle cx="22" cy="22" r="17.083" />
                    <path d="M29.333 14.667 14.667 29.333m14.666 0L14.667 14.667" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </svg>
        </div>
    )
}

export default ErrorIcon
